module.exports = __webpack_public_path__ + "static/media/iconMagic2.14ebee86.svg";